module.exports = __webpack_public_path__ + "img/1.64292aa.png";